import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { inject as service } from "@ember/service"
import { CHANGE_UNIT_COLOR } from "cc-frontend/lib/actions/course/calendar/CHANGE_UNIT_COLOR"
import styles from "./color-selector.module.css"

@tagName("")
export default class UnitColorSelector extends Component {
  @service dispatcher

  styles = styles

  courseColors = [
    "yellow",
    "muted-yellow",
    "muted-green",
    "green",

    "turquoise",
    "muted-turquoise",
    "muted-cyan",
    "cyan",

    "blue",
    "muted-blue",
    "muted-purple",
    "purple",

    "pink",
    "muted-pink",
    "muted-coral",
    "coral",
  ]

  colorMenuIsOpen = false

  @action
  toggleMenu() {
    if (!this.isEditable) return
    set(this, "colorMenuIsOpen", !this.colorMenuIsOpen)
  }

  @action
  closeMenu(id) {
    set(this, "colorMenuIsOpen", false)
  }

  @action
  setUnitColor(unitId, color, courseId, originalColor) {
    if (!this.isEditable) return

    get(this, "dispatcher").dispatchAction(CHANGE_UNIT_COLOR, {
      courseId: courseId,
      cardStackId: unitId,
      color: color,
      originalValue: originalColor,
    })
    set(this, "colorMenuIsOpen", false)
  }
}
